import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getPublicCategoryOptions, type PublicOptionResponse } from "./publicOptions.api";

interface UseGetCategoryOptionsReturn {
  categoryOptions: PublicOptionResponse[];
  fetchCategoryOptions: () => Promise<void>;
}

export const useGetCategoryOptions = (): UseGetCategoryOptionsReturn => {
  const [categoryOptions, setCategoryOptions] = useState<PublicOptionResponse[]>([]);
  const { run: runLatestRequest } = useLatestRequest();

  const fetchCategoryOptions = useCallback(async () => {
    try {
      const response = await runLatestRequest(getPublicCategoryOptions);
      if (!response) return;
      setCategoryOptions(response);
    } catch (error) {
      console.error("Failed to fetch category options:", error);
    }
  }, [runLatestRequest]);

  return {
    categoryOptions,
    fetchCategoryOptions,
  };
};
